import { useState } from 'react';
import { OrderProperty } from 'types/order';

type ModalState = {
  kind: 'Proprietor' | 'Ownership'
}

type Params = {
  selectedProperty: OrderProperty,
}

export const useTabOwnershipHooks = ({ selectedProperty }: Params) => {
  const [modalState, setModalState] = useState<ModalState | null>(null);

  const handleCloseModal = () => {
    setModalState(null);
  };

  const handleShowSplitModal = (kind: 'Proprietor' | 'Ownership') => {
    setModalState({
      kind,
    });
  };

  const purchasePriceEntry = selectedProperty.accounting.find(entry => entry.code === `purchase_price_${selectedProperty._id}`);

  const ownerships = purchasePriceEntry ? purchasePriceEntry.involved_parties
    .filter((party) => party.kind === "Ownership") : [];

  const proprietors = purchasePriceEntry ? purchasePriceEntry.involved_parties
    .filter((party) => party.kind === "Proprietor") : [];

  return {
    modalState,
    handleCloseModal,
    purchasePriceEntry,
    handleShowSplitModal,
    ownerships,
    proprietors
  };
};
